import * as React from "react";
import { Card } from "antd";
import { INotice } from "../../../model/notice/Notice";

const renderCardItem = (notice: INotice, translate: any) => {
  return (
    <Card
      className={"notice-card"}
      type="inner"
      title={notice.title}
      onClick={() => window.open(notice.urlLink)}
      extra={
        <a
          className={"notice-card-link"}
          href={notice.urlLink}
          target={"_blank"}
        >
          {translate("portal.notice.show_more")}
        </a>
      }
      style={{ marginBottom: 16 }}
    >
      {notice.summary}
    </Card>
  );
};

const NoticeList = ({
  noticeList,
  translate
}: {
  noticeList: INotice[];
  translate: any;
}) => {
  return (
    <Card
      className={"main-notice-card"}
      title={translate("portal.notice.notices")}
    >
      {noticeList.map((notice) => renderCardItem(notice, translate))}
    </Card>
  );
};

export default NoticeList;
